export default {
    properties: [],
    warehouses: [],
    parkinglots: [],
    filter_project: {},
    property_select: {},
    properties_extra_data: {}
}